module.exports = __webpack_public_path__ + "img/ug.e54d019e.svg";